// extracted by mini-css-extract-plugin
export default {"ellipsis":"Q95Jrw7U6AOTRjowRStc","wrapper":"MDVK49M7tuv8a1gC4mZk","name":"_FtuHJbpISqZ_3WWilvQ","members":"BhFDr1c8KAcwl6p1mGoB","spin":"Qf1MrefXDQZtjihbC8Rw"};